import PATH from "constants/path";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { SERVICE } from "constants/global";
import { setCookie } from "utils/common";
import { getUser } from "features/User/userSlice";
import { Notice } from "components";

function Account() {
  const history = useHistory();
  const dispatch = useDispatch();

  const { user, noticesInit } = useSelector((state) => state.user);

  useEffect(() => {
    if (!user) {
      dispatch(getUser());
    }
  }, []);

  if (!user) return null;

  return (
    <div className="w-80 py-0 py-md-3 ">
      <Notice noticesInit={noticesInit} />

      <div className="fs-20 fs-sm-18 fw-600 my-3 my-md-4 text-center">
        口座情報
      </div>

      {user.bank_type == 1 ? (
        <div className="px-3 px-md-0">
          <table className="table-view my-3 border-radius-0 border-radius-sm-5 w-100">
            <tbody>
              <tr>
                <td className="fs-14 fw-600 ps-3">金融機関種別</td>
                <td className="ps-2 ps-md-3">ゆうちょ銀行</td>
              </tr>
              <tr>
                <td className="fs-14 fw-600 ps-3">通帳記号</td>
                <td className="ps-2 ps-md-3">{user?.yucho_code}</td>
              </tr>
              <tr>
                <td className="fs-14 fw-600 ps-3">通帳番号</td>
                <td className="ps-2 ps-md-3">{user?.yucho_account_number}</td>
              </tr>
              <tr>
                <td className="fs-14 fw-600 ps-3">通帳名義(カナ)</td>
                <td className="ps-2 ps-md-3">{user?.yucho_account_name}</td>
              </tr>
            </tbody>
          </table>
        </div>
      ) : user.bank_type == 2 ? (
        <div className="px-3 px-md-0">
          <table className="table-view my-3 border-radius-0 border-radius-sm-5 w-100">
            <tbody>
              <tr>
                <td className="fs-14 fw-600 ps-3">金融機関種別</td>
                <td className="ps-2 ps-md-3">ゆうちょ銀行以外</td>
              </tr>
              <tr>
                <td className="fs-14 fw-600 ps-3">金融機関名</td>
                <td className="ps-2 ps-md-3">{user?.bank_name}</td>
              </tr>
              <tr>
                <td className="fs-14 fw-600 ps-3">金融機関番号</td>
                <td className="ps-2 ps-md-3">{user?.bank_code}</td>
              </tr>
              <tr>
                <td className="fs-14 fw-600 ps-3">支店名</td>
                <td className="ps-2 ps-md-3">{user?.branch_name}</td>
              </tr>
              <tr>
                <td className="fs-14 fw-600 ps-3">支店番号</td>
                <td className="ps-2 ps-md-3">{user?.branch_code}</td>
              </tr>
              <tr>
                <td className="fs-14 fw-600 ps-3">口座番号</td>
                <td className="ps-2 ps-md-3">{user?.account_number}</td>
              </tr>
              <tr>
                <td className="fs-14 fw-600 ps-3">口座名義(カナ)</td>
                <td className="ps-2 ps-md-3">{user?.account_name}</td>
              </tr>
            </tbody>
          </table>
        </div>
      ) : (
        <div className="border-color-red-light border-radius-sm-5 p-2 mx-3 mx-md-0 text-center fs-14 sp-14 fw-600 text-red-light">
          口座情報は登録されておりません
        </div>
      )}

      <div className="group-btn-update my-4 my-md-5 px-3 px-md-0">
        <div onClick={() => history.push(PATH.SETTING)} className="btn-update">
          戻る
        </div>
        <div
          onClick={() => {
            window.location = `${PATH.COMMON}${PATH.UPDATE_BANK.EDIT}?service=${SERVICE}&url_back=${window.location.href}`;
          }}
          className="btn-update red-light"
        >
          登録・変更する
        </div>
      </div>
    </div>
  );
}

export default Account;
